import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import {
  FaStethoscope,
  FaPrescriptionBottle,
  FaClipboardList,
  FaMicroscope,
  FaFileMedical,
  FaChevronRight,
  FaChevronLeft,
} from 'react-icons/fa';

function SideMenu({ onMenuItemClick }) {
  const [isOpen, setIsOpen] = useState(false);
  const [userPlan, setUserPlan] = useState('Gratuito');
  const auth = getAuth();
  const db = getFirestore();
  const user = auth.currentUser;
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const fetchUserPlan = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          setUserPlan(userDoc.data().plano);
        }
      }
    };
    fetchUserPlan();

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', () => setIsOpen(false));
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [user, db]);

  const isRouteDisabled = (route) => {
    if (
      userPlan === 'Gratuito' &&
      ['atestado', 'agenda', 'historico', 'pedidoCirurgia'].includes(route)
    ) {
      return true;
    }
    return false;
  };

  return (
    <nav
      ref={menuRef}
      className={`fixed top-1/2 left-0 transform -translate-y-1/2 bg-white shadow-lg border-r-2 border-gray-200 ${
        isOpen ? 'w-64' : 'w-16'
      } transition-width duration-300 z-50 rounded-r-lg`}
      aria-label="Menu de navegação"
    >
      <div className="flex justify-center py-4">
        <button
          className="bg-primary text-white p-2 rounded-full flex items-center justify-center focus:outline-none hover:bg-secondary transition-transform transform hover:translate-y-1"
          onClick={toggleMenu}
          aria-expanded={isOpen}
          aria-controls="sideMenu-list"
          aria-label="Toggle menu"
        >
          {isOpen ? <FaChevronLeft /> : <FaChevronRight />}
        </button>
      </div>
      <div
        id="sideMenu-list"
        className="flex flex-col items-start p-4 space-y-4"
      >
        <button
          onClick={() => onMenuItemClick('atendimento')}
          className={`flex items-center text-gray-700 hover:bg-primary hover:text-white w-full p-2 rounded-md transition-colors duration-300 focus:outline-none ${
            isOpen ? 'justify-start' : 'justify-center'
          }`}
          disabled={isRouteDisabled('atendimento')}
        >
          <FaStethoscope size={20} />
          {isOpen && <span className="ml-3">Atendimento</span>}
        </button>
        <button
          onClick={() =>
            !isRouteDisabled('receita') && onMenuItemClick('receita')
          }
          className={`flex items-center text-gray-700 hover:bg-primary hover:text-white w-full p-2 rounded-md transition-colors duration-300 focus:outline-none ${
            isOpen ? 'justify-start' : 'justify-center'
          } ${isRouteDisabled('receita') ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <FaPrescriptionBottle size={20} />
          {isOpen && <span className="ml-3">Gerar Receita</span>}
        </button>
        <button
          onClick={() =>
            !isRouteDisabled('atestado') && onMenuItemClick('atestado')
          }
          className={`flex items-center text-gray-700 hover:bg-primary hover:text-white w-full p-2 rounded-md transition-colors duration-300 focus:outline-none ${
            isOpen ? 'justify-start' : 'justify-center'
          } ${isRouteDisabled('atestado') ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <FaFileMedical size={20} />
          {isOpen && <span className="ml-3">Gerar Atestado</span>}
        </button>
        <button
          onClick={() => onMenuItemClick('pedidosCirurgia')}
          className={`flex items-center text-gray-700 hover:bg-primary hover:text-white w-full p-2 rounded-md transition-colors duration-300 focus:outline-none ${
            isOpen ? 'justify-start' : 'justify-center'
          } ${isRouteDisabled('pedidoCirurgia') ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <FaClipboardList size={20} />
          {isOpen && <span className="ml-3">Pedidos de Cirurgias</span>}
        </button>
        <button
          onClick={() =>
            !isRouteDisabled('historico') && onMenuItemClick('historico')
          }
          className={`flex items-center text-gray-700 hover:bg-primary hover:text-white w-full p-2 rounded-md transition-colors duration-300 focus:outline-none ${
            isOpen ? 'justify-start' : 'justify-center'
          } ${isRouteDisabled('historico') ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <FaMicroscope size={20} />
          {isOpen && <span className="ml-3">Pedidos de Exames</span>}
        </button>
      </div>
    </nav>
  );
}

// Validação de propriedades com PropTypes
SideMenu.propTypes = {
  onMenuItemClick: PropTypes.func.isRequired,
};

export default SideMenu;
